import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export const VisualBreak3 = () => {
  return <section className="relative h-[30vh] md:h-[40vh] w-full overflow-hidden bg-brand-darker flex items-center justify-center" data-id="element-185">
      <div className="absolute inset-0" data-id="element-186">
        <img src="https://cdn.magicpatterns.com/uploads/c7DtgUV4minxineBKqyaMP/IMG_2681-PROOF-THOMAS-MASOTTI.jpg" alt="Ambiance du studio de détatouage Dispel Your Tattoo" className="w-full h-full object-cover grayscale opacity-10" loading="lazy" data-id="element-187" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-brand-darker via-transparent to-brand-darker" data-id="element-188"></div>

      {/* Subtle horizontal line for cinematic feel */}
      <motion.div initial={{
      scaleX: 0,
      opacity: 0
    }} whileInView={{
      scaleX: 1,
      opacity: 0.5
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 2,
      ease: [0.16, 1, 0.3, 1]
    }} className="relative z-10 w-1/3 h-[1px] bg-brand-light/20 origin-center" data-id="element-189" />
    </section>;
};